

export const funcComments = [
  {
    ID: '00000',
    PageID: 'page-a-01',
    DataID: '',
    DataName: '',
    CommentType: 0,
    CommentCategory: 0,
    UserID: '63dc8b9c-cc85-473c-97af-885d8988b859',
    UserName: 'FASTester',
    UserAvatar: 'http://api.teld.cn:8001/img/YHTX/63610745407366025330270.jpg',
    Content: '大家是一个团队，分工合作，各自做好自己的事情，我们就是齿轮加传送带，做好动力输出，让企业更好更快的 RUN RN RUN~',
    CommentTime: '2024/01/25 18:01:23',
    Liked: true,
    LikeCount: 96,
    IsFavorite: true,
    FavoriteCount: 9,
    ReplyCount: 0,
    CanCancel: true,
    IsDeleted: false,
    Replies: [],
  },
  {
    ID: '00001',
    PageID: 'page-a-01',
    DataID: '',
    DataName: '',
    CommentType: 0,
    CommentCategory: 0,
    UserID: 'user-001',
    UserName: '公孙离',
    UserAvatar: 'https://iph.href.lu/60x60?text=公孙离&bg=9fc5e8&fg=ffffff',
    Content: '前端完全可以不知道自己在干什么而照常工作',
    CommentTime: '2024/01/23 10:12:10',
    Liked: true,
    LikeCount: 6,
    IsFavorite: true,
    FavoriteCount: 8,
    ReplyCount: 6,
    CanCancel: true,
    IsDeleted: false,
    Replies: [
      {
        ID: 'comment-reply-001',
        CommentID: '00001',
        Content: '这不就是我吗，我对业务的了解远不如后端和测试，有一些功能我自己都不会用…',
        UserID: 'user-002',
        UserName: '鲁班7号',
        IsAuthor: true,
        UserAvatar: 'https://iph.href.lu/60x60?text=鲁班7号&bg=9fc5e8&fg=ffffff',
        ReplyTime: '2024/01/23 10:22:10',
        Liked: false,
        LikeCount: 0,
        IsFavorite: false,
        FavoriteCount: 0,
        CanCancel: true,
        IsDeleted: false,
      },
      {
        ID: 'comment-reply-002',
        CommentID: '00001',
        Content: '经常这样，我也不知道为什么要这么做，后端说你这么做，我就照着做了',
        UserID: 'user-003',
        UserName: '虞姬',
        UserAvatar: 'https://iph.href.lu/60x60?text=虞姬&bg=9fc5e8&fg=ffffff',
        ReplyTime: '2024/01/23 10:20:10',
        Liked: false,
        LikeCount: 0,
        IsFavorite: false,
        FavoriteCount: 0,
        CanCancel: true,
        IsDeleted: false,
      },
      {
        ID: 'comment-reply-003',
        CommentID: '00001',
        Content: '太现实了',
        UserID: 'user-004',
        UserName: '狄仁杰',
        UserAvatar: 'https://iph.href.lu/60x60?text=狄仁杰&bg=9fc5e8&fg=ffffff',
        ReplyTime: '2024/01/23 10:16:22',
        Liked: false,
        LikeCount: 0,
        IsFavorite: false,
        FavoriteCount: 0,
        CanCancel: true,
        IsDeleted: false,
      },
      {
        ID: 'comment-reply-004',
        CommentID: '00001',
        Content: '太精辟了',
        UserID: 'user-005',
        UserName: '伽罗',
        UserAvatar: 'https://iph.href.lu/60x60?text=伽罗&bg=9fc5e8&fg=ffffff',
        ReplyTime: '2024/01/23 10:15:07',
        Liked: false,
        LikeCount: 0,
        IsFavorite: false,
        FavoriteCount: 0,
        CanCancel: true,
        IsDeleted: false,
      },
      {
        ID: 'comment-reply-005',
        CommentID: '00001',
        Content: '我一个后端也这样，没救了',
        UserID: 'user-006',
        UserName: '戈亚',
        UserAvatar: 'https://iph.href.lu/60x60?text=戈亚&bg=9fc5e8&fg=ffffff',
        ReplyTime: '2024/01/23 10:14:22',
        Liked: false,
        LikeCount: 0,
        IsFavorite: false,
        FavoriteCount: 0,
        CanCancel: true,
        IsDeleted: false,
      },
      {
        ID: 'comment-reply-006',
        CommentID: '00001',
        Content: '一个字，真实',
        UserID: 'user-007',
        UserName: '马可波罗',
        UserAvatar: 'https://iph.href.lu/60x60?text=马可波罗&bg=9fc5e8&fg=ffffff',
        ReplyTime: '2024/01/23 10:14:02',
        Liked: false,
        LikeCount: 0,
        IsFavorite: false,
        FavoriteCount: 0,
        CanCancel: true,
        IsDeleted: false,
      },
    ],
  },
  {
    ID: '00002',
    PageID: 'page-a-01',
    DataID: '',
    DataName: '',
    CommentType: 0,
    CommentCategory: 0,
    UserID: 'user-008',
    UserName: '后羿',
    UserAvatar: 'https://iph.href.lu/60x60?text=后羿&bg=9fc5e8&fg=ffffff',
    Content: '15年以前写前端是很困难的事情，那时候前端香工资高，后来前端技术大爆发，门槛极速堕落，各种框架包邮到家。现在确实不值钱，但是玩的好的前端转全栈厉害了，懂的都懂。前端写后端接口协议甚至更规范，然而后端写前端效率不到十分之一。我已经转全栈了，从java、linux命令一路写到硬件嵌入式代码，关键是根本无缝衔接，经历过js技术大爆炸，再看其他语言的语法和机制就感觉太纯粹太简单了。',
    CommentTime: '2024/01/23 10:12:10',
    Liked: false,
    LikeCount: 0,
    IsFavorite: false,
    FavoriteCount: 0,
    ReplyCount: 4,
    CanCancel: true,
    IsDeleted: false,
    Replies: [
      {
        ID: 'comment-reply-007',
        CommentID: '00002',
        Content: '这不就是我吗，我对业务的了解远不如后端和测试，有一些功能我自己都不会用…',
        UserID: 'user-002',
        UserName: '鲁班7号',
        IsAuthor: true,
        UserAvatar: 'https://iph.href.lu/60x60?text=鲁班7号&bg=9fc5e8&fg=ffffff',
        ReplyTime: '2024/01/23 10:12:10',
        Liked: false,
        LikeCount: 0,
        IsFavorite: false,
        FavoriteCount: 0,
        CanCancel: true,
        IsDeleted: false,
      },
      {
        ID: 'comment-reply-008',
        CommentID: '00002',
        Content: '那你学后端啊，还有老老实实带痛苦面具刷题，你毕业时，要是还有饭吃，不得人均几道hard开路啊',
        UserID: 'user-003',
        UserName: '虞姬',
        UserAvatar: 'https://iph.href.lu/60x60?text=虞姬&bg=9fc5e8&fg=ffffff',
        ReplyTime: '2024/01/23 10:11:10',
        Liked: false,
        LikeCount: 0,
        IsFavorite: false,
        FavoriteCount: 0,
        CanCancel: true,
        IsDeleted: false,
      },
      {
        ID: 'comment-reply-009',
        CommentID: '00002',
        Content: '早点了解市场，看看社招都要什么技能，选个方向学下去',
        UserID: 'user-004',
        UserName: '狄仁杰',
        UserAvatar: 'https://iph.href.lu/60x60?text=狄仁杰&bg=9fc5e8&fg=ffffff',
        ReplyTime: '2024/01/23 10:13:22',
        Liked: false,
        LikeCount: 0,
        IsFavorite: false,
        FavoriteCount: 0,
        CanCancel: true,
        IsDeleted: false,
      },
      {
        ID: 'comment-reply-0010',
        CommentID: '00002',
        Content: '我现在大一，进了学校社团技术部的前端，不知道现在应不应该继续花时间，毕竟社团也会布置任务敦促我去学[捂脸]主要现在学了以后也还不知道要干嘛',
        UserID: 'user-005',
        UserName: '伽罗',
        UserAvatar: 'https://iph.href.lu/60x60?text=伽罗&bg=9fc5e8&fg=ffffff',
        ReplyTime: '2024/01/23 09:22:08',
        Liked: false,
        LikeCount: 0,
        IsFavorite: false,
        FavoriteCount: 0,
        CanCancel: true,
        IsDeleted: false,
      },
    ],
  },
  {
    ID: '00003',
    PageID: 'page-a-01',
    DataID: '',
    DataName: '',
    CommentType: 0,
    CommentCategory: 0,
    UserID: 'user-008',
    UserName: '孙尚香',
    UserAvatar: 'https://iph.href.lu/60x60?text=孙尚香&bg=9fc5e8&fg=ffffff',
    Content: '大小姐驾到，统统闪开~所以前后端分离这事 就有问题 应该是前后端技术分离 人不分离 就是一个人既能写前端又可以写后端',
    CommentTime: '2024/01/23 10:12:10',
    Liked: false,
    LikeCount: 0,
    IsFavorite: false,
    FavoriteCount: 0,
    ReplyCount: 6,
    CanCancel: true,
    IsDeleted: false,
    Replies: [
      {
        ID: 'comment-reply-011',
        CommentID: '00003',
        Content: '是的，那公司给的薪资得是匹配上全栈的工资吧。总不能给一个后端几k得工资要你干全栈得活吧',
        UserID: 'user-002',
        UserName: '鲁班7号',
        IsAuthor: true,
        UserAvatar: 'https://iph.href.lu/60x60?text=鲁班7号&bg=9fc5e8&fg=ffffff',
        ReplyTime: '2024/01/23 10:12:10',
        Liked: false,
        LikeCount: 0,
        IsFavorite: false,
        FavoriteCount: 0,
        CanCancel: true,
        IsDeleted: false,
      },
      {
        ID: 'comment-reply-012',
        CommentID: '00003',
        Content: '前后端分离的目的是提速，不然一个人干了，工期不就同步阻塞了么',
        UserID: 'user-003',
        UserName: '虞姬',
        UserAvatar: 'https://iph.href.lu/60x60?text=虞姬&bg=9fc5e8&fg=ffffff',
        ReplyTime: '2024/01/23 10:11:10',
        Liked: false,
        LikeCount: 0,
        IsFavorite: false,
        FavoriteCount: 0,
        CanCancel: true,
        IsDeleted: false,
        // ReplyTo: {
        //   UserID: 'user-002',
        //   UserName: '鲁班7号',
        //   UserAvatar: 'https://iph.href.lu/60x60?text=鲁班7号&bg=9fc5e8&fg=ffffff',
        // },
        RespondedUserID: 'user-002',
        RespondedUserName: '鲁班7号',
      },
      {
        ID: 'comment-reply-013',
        CommentID: '00003',
        Content: '分离分离再分离就成微服务了。',
        UserID: 'user-004',
        UserName: '狄仁杰',
        UserAvatar: 'https://iph.href.lu/60x60?text=狄仁杰&bg=9fc5e8&fg=ffffff',
        ReplyTime: '2024/01/23 10:13:22',
        Liked: false,
        LikeCount: 0,
        IsFavorite: false,
        FavoriteCount: 0,
        CanCancel: true,
        IsDeleted: false,
      },
      {
        ID: 'comment-reply-0014',
        CommentID: '00003',
        Content: '说得好，赶紧成立公司',
        UserID: 'user-005',
        UserName: '伽罗',
        UserAvatar: 'https://iph.href.lu/60x60?text=伽罗&bg=9fc5e8&fg=ffffff',
        ReplyTime: '2024/01/23 09:22:08',
        Liked: false,
        LikeCount: 0,
        IsFavorite: false,
        FavoriteCount: 0,
        CanCancel: true,
        IsDeleted: false,
      },
      {
        ID: 'comment-reply-015',
        CommentID: '00003',
        Content: '前后端分离的目的是提速，不然一个人干了，工期不就同步阻塞了么？',
        UserID: 'user-006',
        UserName: '戈亚',
        UserAvatar: 'https://iph.href.lu/60x60?text=戈亚&bg=9fc5e8&fg=ffffff',
        ReplyTime: '2024/01/23 10:14:22',
        Liked: false,
        LikeCount: 0,
        IsFavorite: false,
        FavoriteCount: 0,
        CanCancel: true,
        IsDeleted: false,
      },
      {
        ID: 'comment-reply-016',
        CommentID: '00003',
        Content: '那些一个人干的 前端做的95%都是屎啊',
        UserID: 'user-007',
        UserName: '马可波罗',
        UserAvatar: 'https://iph.href.lu/60x60?text=马可波罗&bg=9fc5e8&fg=ffffff',
        ReplyTime: '2024/01/23 10:14:02',
        Liked: false,
        LikeCount: 0,
        IsFavorite: false,
        FavoriteCount: 0,
        CanCancel: true,
        IsDeleted: false,
      },
    ],
  },
];

export const dataComments = [
  {
    ID: '00001',
    PageID: 'page-a-01',
    DataID: 'data-a-01',
    DataName: '为什么后端老是觉得前端简单?',
    CommentType: 0,
    CommentCategory: 0,
    UserID: 'user-001',
    UserName: '公孙离',
    UserAvatar: 'https://iph.href.lu/60x60?text=公孙离&bg=9fc5e8&fg=ffffff',
    Content: '前端完全可以不知道自己在干什么而照常工作',
    CommentTime: '2024/01/23 10:12:10',
    Liked: false,
    LikeCount: 0,
    IsFavorite: false,
    FavoriteCount: 0,
    ReplyCount: 6,
    CanCancel: true,
    IsDeleted: false,
    Replies: [
      {
        ID: 'comment-reply-001',
        CommentID: '00001',
        Content: '这不就是我吗，我对业务的了解远不如后端和测试，有一些功能我自己都不会用…',
        UserID: 'user-002',
        UserName: '鲁班7号',
        IsAuthor: true,
        UserAvatar: 'https://iph.href.lu/60x60?text=鲁班7号&bg=9fc5e8&fg=ffffff',
        ReplyTime: '2024/01/23 10:22:10',
        Liked: false,
        LikeCount: 0,
        IsFavorite: false,
        FavoriteCount: 0,
        CanCancel: true,
        IsDeleted: false,
      },
      {
        ID: 'comment-reply-002',
        CommentID: '00001',
        Content: '经常这样，我也不知道为什么要这么做，后端说你这么做，我就照着做了',
        UserID: 'user-003',
        UserName: '虞姬',
        UserAvatar: 'https://iph.href.lu/60x60?text=虞姬&bg=9fc5e8&fg=ffffff',
        ReplyTime: '2024/01/23 10:20:10',
        Liked: false,
        LikeCount: 0,
        IsFavorite: false,
        FavoriteCount: 0,
        CanCancel: true,
        IsDeleted: false,
        // ReplyTo: {
        //   UserID: 'user-002',
        //   UserName: '鲁班7号',
        //   UserAvatar: 'https://iph.href.lu/60x60?text=鲁班7号&bg=9fc5e8&fg=ffffff',
        // },
        RespondedUserID: 'user-002',
        RespondedUserName: '鲁班7号',
      },
      {
        ID: 'comment-reply-003',
        CommentID: '00001',
        Content: '太现实了',
        UserID: 'user-004',
        UserName: '狄仁杰',
        UserAvatar: 'https://iph.href.lu/60x60?text=狄仁杰&bg=9fc5e8&fg=ffffff',
        ReplyTime: '2024/01/23 10:16:22',
        Liked: false,
        LikeCount: 0,
        IsFavorite: false,
        FavoriteCount: 0,
        CanCancel: true,
        IsDeleted: false,
      },
      {
        ID: 'comment-reply-004',
        CommentID: '00001',
        Content: '太精辟了',
        UserID: 'user-005',
        UserName: '伽罗',
        UserAvatar: 'https://iph.href.lu/60x60?text=伽罗&bg=9fc5e8&fg=ffffff',
        ReplyTime: '2024/01/23 10:15:07',
        Liked: false,
        LikeCount: 0,
        IsFavorite: false,
        FavoriteCount: 0,
        CanCancel: true,
        IsDeleted: false,
        // ReplyTo: {
        //   UserID: 'user-004',
        //   UserName: '狄仁杰',
        //   UserAvatar: 'https://iph.href.lu/60x60?text=狄仁杰&bg=9fc5e8&fg=ffffff',
        // },
        RespondedUserID: 'user-004',
        RespondedUserName: '狄仁杰',
      },
      {
        ID: 'comment-reply-005',
        CommentID: '00001',
        Content: '我一个后端也这样，没救了',
        UserID: 'user-006',
        UserName: '戈亚',
        UserAvatar: 'https://iph.href.lu/60x60?text=戈亚&bg=9fc5e8&fg=ffffff',
        ReplyTime: '2024/01/23 10:14:22',
        Liked: false,
        LikeCount: 0,
        IsFavorite: false,
        FavoriteCount: 0,
        CanCancel: true,
        IsDeleted: false,
      },
      {
        ID: 'comment-reply-006',
        CommentID: '00001',
        Content: '一个字，真实',
        UserID: 'user-007',
        UserName: '马可波罗',
        UserAvatar: 'https://iph.href.lu/60x60?text=马可波罗&bg=9fc5e8&fg=ffffff',
        ReplyTime: '2024/01/23 10:14:02',
        Liked: false,
        LikeCount: 0,
        IsFavorite: false,
        FavoriteCount: 0,
        CanCancel: true,
        IsDeleted: false,
      },
    ],
  },
  {
    ID: '00002',
    PageID: 'page-a-01',
    DataID: 'data-a-01',
    DataName: '为什么后端老是觉得前端简单?',
    CommentType: 0,
    CommentCategory: 0,
    UserID: 'user-008',
    UserName: '后羿',
    UserAvatar: 'https://iph.href.lu/60x60?text=后羿&bg=9fc5e8&fg=ffffff',
    Content: '15年以前写前端是很困难的事情，那时候前端香工资高，后来前端技术大爆发，门槛极速堕落，各种框架包邮到家。现在确实不值钱，但是玩的好的前端转全栈厉害了，懂的都懂。前端写后端接口协议甚至更规范，然而后端写前端效率不到十分之一。我已经转全栈了，从java、linux命令一路写到硬件嵌入式代码，关键是根本无缝衔接，经历过js技术大爆炸，再看其他语言的语法和机制就感觉太纯粹太简单了。',
    CommentTime: '2024/01/23 10:12:10',
    Liked: false,
    LikeCount: 0,
    IsFavorite: false,
    FavoriteCount: 0,
    ReplyCount: 4,
    CanCancel: true,
    IsDeleted: false,
    Replies: [
      {
        ID: 'comment-reply-007',
        CommentID: '00002',
        Content: '这不就是我吗，我对业务的了解远不如后端和测试，有一些功能我自己都不会用…',
        UserID: 'user-002',
        UserName: '鲁班7号',
        UserAvatar: 'https://iph.href.lu/60x60?text=鲁班7号&bg=9fc5e8&fg=ffffff',
        ReplyTime: '2024/01/23 10:12:10',
        Liked: false,
        LikeCount: 0,
        IsFavorite: false,
        FavoriteCount: 0,
        CanCancel: true,
        IsDeleted: false,
      },
      {
        ID: 'comment-reply-008',
        CommentID: '00002',
        Content: '那你学后端啊，还有老老实实带痛苦面具刷题，你毕业时，要是还有饭吃，不得人均几道hard开路啊',
        UserID: 'user-003',
        UserName: '虞姬',
        UserAvatar: 'https://iph.href.lu/60x60?text=虞姬&bg=9fc5e8&fg=ffffff',
        ReplyTime: '2024/01/23 10:11:10',
        Liked: false,
        LikeCount: 0,
        IsFavorite: false,
        FavoriteCount: 0,
        CanCancel: true,
        IsDeleted: false,
      },
      {
        ID: 'comment-reply-009',
        CommentID: '00002',
        Content: '早点了解市场，看看社招都要什么技能，选个方向学下去',
        UserID: 'user-004',
        UserName: '狄仁杰',
        UserAvatar: 'https://iph.href.lu/60x60?text=狄仁杰&bg=9fc5e8&fg=ffffff',
        ReplyTime: '2024/01/23 10:13:22',
        Liked: false,
        LikeCount: 0,
        IsFavorite: false,
        FavoriteCount: 0,
        CanCancel: true,
        IsDeleted: false,
      },
      {
        ID: 'comment-reply-0010',
        CommentID: '00002',
        Content: '我现在大一，进了学校社团技术部的前端，不知道现在应不应该继续花时间，毕竟社团也会布置任务敦促我去学[捂脸]主要现在学了以后也还不知道要干嘛',
        UserID: 'user-005',
        UserName: '伽罗',
        UserAvatar: 'https://iph.href.lu/60x60?text=伽罗&bg=9fc5e8&fg=ffffff',
        ReplyTime: '2024/01/23 09:22:08',
        Liked: false,
        LikeCount: 0,
        IsFavorite: false,
        FavoriteCount: 0,
        CanCancel: true,
        IsDeleted: false,
      },
    ],
  }
];

export const getCommentReplies = () => {
  //
}

// export default {

// }
